import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

/* ##########################################
#             LOAD BASE COMPONENTS          #
########################################### */

// load layout components at startup and make them available in the whole application

// import all .vue files in components/base
const requireComponent = require.context(
  '@/components/base',
  true,
  /\.vue$/
)

// Convert filename from file path to a valid component name camelcase and capitalized
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  )

  // load components export default configuration or root configuration
  Vue.component(componentName, componentConfig.default || componentConfig)
})
